// Helpers for reading and formatting a tenant's subscription end-date.
//
// The exact field name on the Organization payload is still being confirmed
// on the backend (see sprint-tenant-admin-redesign.md "Öppna frågor"), so we
// accept the most likely candidates and normalise here.

const END_DATE_FIELDS = ['endDate', 'subscriptionEndDate', 'endOfLifeDate'];
const REASON_FIELDS = ['endDateReason', 'subscriptionEndReason'];

const MS_PER_DAY = 24 * 60 * 60 * 1000;

const startOfUtcDay = (date) =>
  Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());

export const getOrganizationEndDate = (organization) => {
  if (!organization) return null;

  for (const field of END_DATE_FIELDS) {
    const value = organization[field];
    if (!value) continue;
    const parsed = new Date(value);
    if (!Number.isNaN(parsed.getTime())) return parsed;
  }

  return null;
};

export const getOrganizationEndDateReason = (organization) => {
  if (!organization) return null;

  for (const field of REASON_FIELDS) {
    if (organization[field]) return organization[field];
  }

  return null;
};

export const formatOrganizationEndDate = (organization, now = new Date()) => {
  const date = getOrganizationEndDate(organization);
  if (!date) return null;

  const diffDays = Math.round(
    (startOfUtcDay(date) - startOfUtcDay(now)) / MS_PER_DAY
  );

  let daysLabel;
  if (diffDays === 0) {
    daysLabel = 'today';
  } else if (diffDays > 0) {
    daysLabel = `in ${diffDays} day${diffDays === 1 ? '' : 's'}`;
  } else {
    const past = Math.abs(diffDays);
    daysLabel = `${past} day${past === 1 ? '' : 's'} ago`;
  }

  return {
    date,
    label: date.toISOString().slice(0, 10),
    reasonLabel: getOrganizationEndDateReason(organization),
    daysLabel,
    isPast: diffDays < 0,
  };
};
